'use client'

import { createContext } from 'react'

export const UserContext = createContext({
    isAuthenticated: false,
    webpSupport: false,
})
